module.exports = __webpack_public_path__ + "static/media/img_5.4a0f108f.jpg";